<template>
  <div>
    <div class="events-map-inner" ref="container"></div>
  </div>
</template>

<script>
import axios from 'axios'
import { Loader } from 'google-maps'
import { MarkerClusterer } from '@googlemaps/markerclusterer'
import mapOptions from './mapOptions.json'

export default {
  data() {
    return {
      google: {},
      map: null,
      events: [],
      markers: [],
      clusters: [],
    }
  },
  async mounted() {
    await this.getEvents()
    await this.initMap()
    this.setMarkers()
  },
  methods: {
    async getEvents() {
      await axios
        .get('https://www.swiss.tech/events-map?_format=json')
        .then((response) => {
          this.events = response.data
        })
    },
    async initMap() {
      const loader = new Loader('AIzaSyByIIpjXg5RRpgf7wldoQ4pIaP5CMeOaFo', {})
      this.google = await loader.load()

      this.map = new this.google.maps.Map(this.$refs.container, mapOptions)
    },
    setMarkers() {
      for (const event of this.events) {
        const content = `
          ${event.field_media.replace(
            '/sites/default',
            'https://www.swiss.tech/sites/default',
          )}
          <div class="events-map-infowindow-venue">${event.field_venue}</div>
          <div class="events-map-infowindow-title">${event.title}</div>
          <div class="events-map-infowindow-dates">${event.field_dates}</div>
          <a class="events-map-infowindow-more" href="https://www.swiss.tech${
            event.view_node
          }">View more</a>`

        const infowindow = new this.google.maps.InfoWindow({
          content,
        })

        const mainMarkerImage =
          'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjhweCIgaGVpZ2h0PSIyOHB4IiB2aWV3Qm94PSIwIDAgMjggMjgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+T3ZhbDwvdGl0bGU+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTW9iaWxlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjcuMDAwMDAwLCAtMTM5LjAwMDAwMCkiIGZpbGw9IiNGRkY4MDAiPgogICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBjeD0iODEiIGN5PSIxNTMiIHI9IjE0Ij48L2NpcmNsZT4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=='
        const secMarkerImage =
          'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSIxMnB4IiB2aWV3Qm94PSIwIDAgMTIgMTIiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+T3ZhbDwvdGl0bGU+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTW9iaWxlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMjA5LjAwMDAwMCwgLTI1MS4wMDAwMDApIiBmaWxsPSIjRkYzNzc3Ij4KICAgICAgICAgICAgPGNpcmNsZSBpZD0iT3ZhbCIgY3g9IjIxNSIgY3k9IjI1NyIgcj0iNiI+PC9jaXJjbGU+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4='

        const marker = new this.google.maps.Marker({
          position: this.coordinatesToPosition(event.field_coordinates),
          map: this.map,
          icon: {
            url:
              event.field_secondary_event == 1
                ? secMarkerImage
                : mainMarkerImage,
          },
        })

        marker.addListener('click', () => {
          infowindow.open({
            anchor: marker,
            map: this.map,
            shouldFocus: false,
          })
        })

        this.markers.push(marker)
      }

      setTimeout(() => {
        this.checkMarkersDistance()

        const renderer = {
          render: ({ count, position }) =>
            new this.google.maps.Marker({
              label: { text: String(count), color: '#000', fontSize: '14px' },
              position,
              icon: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjhweCIgaGVpZ2h0PSIyOHB4IiB2aWV3Qm94PSIwIDAgMjggMjgiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+T3ZhbDwvdGl0bGU+CiAgICA8ZyBpZD0iUGFnZS0xIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iTW9iaWxlIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNjcuMDAwMDAwLCAtMzAxLjAwMDAwMCkiIGZpbGw9IiNFRUVFRUUiPgogICAgICAgICAgICA8Y2lyY2xlIGlkPSJPdmFsIiBjeD0iODEiIGN5PSIzMTUiIHI9IjE0Ij48L2NpcmNsZT4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==',
              zIndex: Number(this.google.maps.Marker.MAX_ZINDEX) + count,
            }),
        }

        this.clusters = new MarkerClusterer({
          map: this.map,
          markers: this.markers,
          renderer,
        })
      }, 300)
    },
    checkMarkersDistance() {
      const distances = []
      this.markers.forEach((marker1, index1) => {
        for (let index2 = index1 + 1; index2 < this.markers.length; index2++) {
          const distance = this.getDistanceBetweenMarkers(
            marker1,
            this.markers[index2],
          )
          distances.push({ index1, index2, distance })
        }
      })

      const narrowMarkers = distances.filter(
        (distance) => distance.distance <= 2,
      )

      narrowMarkers.forEach((markers) => {
        this.moveMarker(this.markers[markers.index1], { lat: 0, lng: 0.01 })
        this.moveMarker(this.markers[markers.index2], { lat: 0, lng: -0.01 })
      })
    },
    getDistanceBetweenMarkers(marker1, marker2) {
      const p1 = this.getMarkerPosition(marker1)
      const p2 = this.getMarkerPosition(marker2)
      const pixelSize = Math.pow(2, -this.map.getZoom())
      const distance =
        Math.sqrt(
          (p1.x - p2.x) * (p1.x - p2.x) + (p1.y - p2.y) * (p1.y - p2.y),
        ) / pixelSize

      return distance
    },
    moveMarker(marker, offset) {
      const lat = marker.getPosition().lat()
      const lng = marker.getPosition().lng()
      const latlng = new this.google.maps.LatLng(
        lat + offset.lat,
        lng + offset.lng,
      )
      marker.setPosition(latlng)
    },
    getMarkerPosition(marker) {
      return this.map.getProjection().fromLatLngToPoint(marker.getPosition())
    },
    coordinatesToPosition(coordinates) {
      const coordinatesArray = coordinates.split(' ')

      return {
        lat: parseFloat(coordinatesArray[0]),
        lng: parseFloat(coordinatesArray[1]),
      }
    },
  },
}
</script>

<style lang="scss">
.map {
  height: 500px;
}
</style>
